import { useMemo } from "react";

const useFiltered = <T>(source: T[], test: (it: T) => boolean) => {
  return useMemo(() => {
    return source.filter((it) => test(it));
  }, [source, test]);
};

export default useFiltered;
